









































































































































































































































/** @format */

import { Component, Mixins, Watch } from 'vue-property-decorator';

import listPageMixin from '@root/common/mixins/list-page/list-page.vue';
// import AddEditModal from './components/add-edit-modal.vue'
import toTree, { ITreeNode } from '@root/utils/to-tree';

import * as _ from 'lodash';
import ParkingReviewImage from '../../../components/parking-review-image/index.vue';
import inputNumberWithAddon from '../../../components/input-number-with-addon/index.vue';
// import {DictUserStatus, DictUserStatusMap} from '@/types/system-management/dictionaries'
import { queryRepaireRecord, repaireRecordExport, repaireRecordExamine } from '@/api/exception-management/index';
import ParkingLotSearch from '../../../components/parking-lot-search/index.vue';
import PlateInput from '../../../components/plate-input/index.vue';
import tableColumnData from './tableColumnData';
import detailDialog from '../../../components/detail-dialog/index.vue';
import dataTransferCenter from './dataTransferCenter';

import filterParam from './filterParams';
import Utils from '@root/utils/common';
import { SpecialExitParkReasonMap } from '@/types/exception-management/dictionaries';
import { reviseFromMap } from '@/types/financial-management/dictionaries';
import { dictChannelTypeMap } from '@/types/parking-lot-management/dictionaries';
import { enterOrExit } from '@/api/exception-management/index';
import detailModal from './detail.vue';
import moment from 'moment';
import RangePickerBox from '@/components/range-picker-box/index.vue';

@Component({
  name: 'RepaireRecordRecord',
  components: {
    ParkingReviewImage,
    ParkingLotSearch,
    PlateInput,
    inputNumberWithAddon,
    detailDialog,
    detailModal,
    RangePickerBox
  }
})
export default class RepaireRecordRecord extends Mixins(listPageMixin) {
  private SpecialExitParkReasonList = Utils.toLabelVal(SpecialExitParkReasonMap);
  // 查询条件
  userName = ''; // 账号
  realName = ''; // 真实姓名
  orgDepId: string[] | string | null = null; // 机构Id
  positionId: string = ''; // 岗位id
  searchValue = ''; // 查询条件内容值
  searchType = 'userName'; // 查询条件下拉框当前值
  positionOptions: IOption[] = []; // 岗位下拉选项
  selectedRows = [];
  initialTableColumnData = tableColumnData;
  // 查看图片弹框
  showReviewImgModel: boolean = false;
  // 弹窗控制
  // addEditModalVisible: boolean = false
  //审核意见
  reviewDescriptionOfDialog = '';
  isEdit: boolean = false;
  // addEditModalData: any = []
  viewImageModelData: {} = {}; //查看图片所使用的视图数据
  tableData: any[] = []; // 表数据
  tableLoading: boolean = false;
  currentUser: any = {};
  // reviseFromList = Utils.toLabelVal(reviseFromMap) || []
  reviseFromList =
    Utils.toLabelVal(this.$store.state.dictionaries.allDictionaries.abnormal_operation_source || {}) || [];
  customPrimaryUIConfig = {
    detailDialog: {
      title: '车辆修正详情',
      // cancelText: 'close',
      width: '800px'
    }
  };
  onDetailDialogTypeChange(nv, ov) {
    if ('REVIEW' == nv) {
      this.UI.detailDialog.title = '车辆修正审核';
    } else {
      this.UI.detailDialog.title = '车辆修正详情';
    }
  }

  get dialogCancelText() {
    return 'REVIEW' == this.detailDialogType ? '未通过' : '取消';
  }

  get dialogOKText() {
    return 'REVIEW' == this.detailDialogType ? '通过' : '确定';
  }
  formData: any = {};
  isReview: boolean = false;
  editModel: boolean = false;
  current = 1;
  //展开详情
  showDetail(detail, flag) {
    this.formData = detail;
    this.formData.channelTypeName = this.getChannelName(detail.channelType);
    this.formData.reviseFromName = this.getreviseFromName(detail.reviseFrom);
    this.formData.beforeCarTypeName = detail.beforeCarType == '02' ? '大型车' : '小型车';
    this.formData.afterCarTypeName = detail.afterCarType == '02' ? '大型车' : '小型车';
    this.isReview = flag;
    this.editModel = true;
  }
  handleModalCancel() {
    this.editModel = false;
  }
  async handleModalSave() {
    this.editModel = false;
    if (this.isReview) {
      this.handleModalCreate();
    }
  }
  private validateBeforeSearch = () => {
    if (
      'plateTail' in this.filterParam &&
      (this.filterParam.plateTail || '').trim() !== '' &&
      (this.filterParam.plateHead || '').trim() === ''
    ) {
      this.$message.warning('请选择车牌头');
      return false;
    }
  };
  private requestHandler = {
    list: queryRepaireRecord,
    export: repaireRecordExport,
    exaimine: repaireRecordExamine
  };
  dataTransferCenter = dataTransferCenter;

  //filter-param
  private filterParam: any = filterParam.call(this);
  channelTypeOptions: IOption[] = Utils.toLabelVal(dictChannelTypeMap);
  /**
   * 车牌号组件发生变化
   */
  plateChange([plateHead, plateTail]: any) {
    this.filterParam.plateHead = plateHead;
    this.filterParam.plateTail = plateTail;
  }

  // 查看图片
  reviewImages(record: {}, text: any) {
    console.log('record--:', record);
    this.viewImageModelData = record;
    this.showReviewImgModel = true;
  }

  onTableFilterClearCallback(filterParam: any) {
    filterParam.adapterDataForViewModel.plateModel = true;
  }

  // 查询条件下拉框选项
  get searchOption() {
    return [
      {
        value: 'userName',
        label: '登录账号'
      },
      {
        value: 'realName',
        label: '真实姓名'
      }
    ];
  }

  onDetailDialogConfirm(nodeName: any) {
    this.onDetailDialogCancel(nodeName, '01');
  }

  async onDetailDialogCancel(nodeName: any, reviewStatus = '00') {
    if ('REVIEW' == this.detailDialogType && nodeName == 'BUTTON') {
      let row = this.getBasicInfoByDetailModel();
      let p = {
        // id: row.pkLiftId,
        id: row.pkReviseId,
        parkId: row.parkId,
        orderId: row.orderId,
        reviewStatus: reviewStatus,
        reviewDescription: this.reviewDescriptionOfDialog
      };

      await this.requestHandler.exaimine(p);
      this.$message.success('意见提交成功');
      // @ts-ignore
      this.$refs.detailDialog.hideDialog();
      this.fetchTableData();
    } else {
      // @ts-ignore
      this.$refs.detailDialog.hideDialog();
    }
  }

  // 左右栏配置
  get flexColumns() {
    return [
      {
        id: 'table',
        hiddenHeader: true,
        padding: '0 20px'
      }
    ];
  }

  // 表字段说明
  // get tableColums() {
  //   return tableColumnData.call(this)
  // }

  get reviewColums() {
    return [
      {
        imageSrc: 'img',
        data: [
          {
            label: '车牌',
            dataIndex: 'plate'
          },
          {
            label: '入场时间',
            dataIndex: 'enterTime'
          },
          {
            label: '入场位置',
            dataIndex: 'enterChannelName'
          }
        ]
      }
    ];
  }

  // 所属车场树状图列表
  parkTree: ITreeNode<any>[] = [];
  getParkTreeDebounce: any = null;

  /**
   * 生命周期
   */

  // mounted() {
  //   console.log('$appConfig---:', this.$appConfig)
  //   this.fetchTableData()
  // }

  /**
   * 新建弹窗展示
   */
  // showAddModal() {
  //   this.isEdit = false
  //   this.addEditModalVisible = true
  // }
  /**
   * 点击搜索按钮
   */
  private search() {
    this.current = 1;

    // 时间跨度判断拦截 （单车场可跨365天，多车场最多可跨30天）

    const exitEnterTimeoffsetDays = this.filterParam.parkIds.length === 1 ? 365 : 30;
    if (
      moment(this.filterParam.reviseEndTime).diff(moment(this.filterParam.reviseStartTime), 'days') >
      exitEnterTimeoffsetDays
    ) {
      this.$message.warn(`查询条件：修正时间，跨度不可超过${exitEnterTimeoffsetDays}天`);
      return;
    }

    this.fetchTableData();
  }

  /**
   * 编辑弹窗展示
   */
  // showEditModal(item: any) {
  //   this.isEdit = true
  //   this.addEditModalData = {
  //     ...item,
  //     positionIdList: item.positionList.map((item: any) => item.positionId),
  //   }
  //   this.addEditModalVisible = true
  // }

  /**
   * 弹窗取消
   */
  // handleModalCancel() {
  //   this.addEditModalVisible = false
  // }
  //获取通道类型
  getChannelName(value) {
    const a = _.filter(this.channelTypeOptions, function(o) {
      return o.value == value;
    });
    return a.length > 0 ? a[0].label : '--' || '--';
  }
  //获取操作来源
  getreviseFromName(value) {
    let a = [];
    if (value) {
      a = _.filter(this.reviseFromList, function(o) {
        return o.value == value;
      });
      return a.length > 0 ? a[0].label : '--' || '--';
    }
    return '--';
  }
  //去订单详情页面
  async toDetail(record) {
    if (record) {
      try {
        const { data } = await enterOrExit({ orderId: record.orderId });
        if (!data) return this.$message.error('暂无停车记录详情');
        //在场
        if (data == '00')
          return this.$router.push({ name: 'ENTER_CAR_DETAIL', params: { pkOrderId: record.orderId, from: '01' } });
        if (data == '01')
          //出场
          return this.$router.push({
            name: 'PARKING_RECORD_DETAIL',
            params: { pkOrderId: record.orderId, from: '01' }
          });
      } catch (e) {
        this.$message.error((e && e.msg) || '系统异常请稍后再试');
      }
    }
  }
  /**
   * 弹窗保存
   */
  handleModalCreate() {
    // this.addEditModalVisible = false
    this.fetchTableData();
  }
  getLabelByPropFromModel(prop: any, model: Object, enumLabels: []) {
    if (Number.isInteger(model[prop] - 0)) {
      return enumLabels[model[prop] - 0];
    } else {
      return model[prop];
    }
  }

  /**
   * 表头筛选
   */
  onSortChange({ sortList = [], property, order }) {
    // fetchTableData 查询方法
    sortList.forEach(item => {
      this.filterParam[`${item.property}OrderBy`] = item.order;
    });
    if (!order) {
      this.filterParam[`${property}OrderBy`] = '';
    }
    this.current = 1;
    this.fetchTableData();
  }
  activated() {
    if (this.$route.params.parkIds) {
      this.filterParam.parkIds = this.$route.params.parkIds;
      this.filterParam.reviseStartTime = this.$route.params.time + ' 00:00:00';
      this.filterParam.reviseEndTime = this.$route.params.time + ' 23:59:59';
      this.fetchTableData();
    }
  }

  // 入场时间改变
  onTimeArrChange(date: any, dateString: any) {
    const [startTime, endTime] = dateString;
    this.filterParam.reviseStartTime = startTime;
    this.filterParam.reviseEndTime = endTime;
  }

  /**
   * 时间选择器 值
   */
  get defaultTime() {
    if (this.filterParam.reviseStartTime && this.filterParam.reviseEndTime) {
      return [
        moment(this.filterParam.reviseStartTime, 'YYYY-MM-DD HH:mm:ss'),
        moment(this.filterParam.reviseEndTime, 'YYYY-MM-DD HH:mm:ss')
      ];
    } else if (this.filterParam.reviseStartTime) {
      return [moment(this.filterParam.reviseEndTime, 'YYYY-MM-DD HH:mm:ss')];
    } else {
      return [];
    }
  }
  set defaultTime(val: any) {}
}
